(function () {
  if (window.kgTierInit) return;
  window.kgTierInit = true;

  var EXCLUDED_VENDORS = ['pedal industries', 'abbey bike tools', 're:do', 'route'];

  function isExcluded(item) {
    var v = (item.vendor || '').toLowerCase().trim();
    var t = (item.product_title || '').toLowerCase();
    if (EXCLUDED_VENDORS.indexOf(v) !== -1) return true;
    if (t.indexOf('kolossos st') !== -1) return true;
    if (t.indexOf('route') !== -1) return true;
    if (t.indexOf('great refresh') !== -1) return true;
    return false;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function moneyShort(cents) {
    var s = (cents / 100);
    var str = s % 1 === 0 ? String(s) : s.toFixed(2);
    return '$' + str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function render(el, eligible, excluded) {
    var t1 = +el.dataset.kgTierT1, t2 = +el.dataset.kgTierT2, t3 = +el.dataset.kgTierT3;
    var p1 = +el.dataset.kgTierP1, p2 = +el.dataset.kgTierP2, p3 = +el.dataset.kgTierP3;

    var pct = Math.min(100, eligible * 100 / t3);
    var fill = el.querySelector('[data-kg-tier-fill]');
    if (fill) fill.style.width = pct + '%';

    var current = 0, nextMin = t1, nextPct = p1;
    if (eligible >= t3) { current = p3; nextMin = 0; }
    else if (eligible >= t2) { current = p2; nextMin = t3; nextPct = p3; }
    else if (eligible >= t1) { current = p1; nextMin = t2; nextPct = p2; }

    var head = el.querySelector('.kg-tier__head');
    var badge = el.querySelector('[data-kg-tier-badge]');
    if (current > 0) {
      if (!badge && head) {
        badge = document.createElement('span');
        badge.className = 'kg-tier__badge';
        badge.setAttribute('data-kg-tier-badge', '');
        head.appendChild(badge);
      }
      if (badge) badge.textContent = current + '% unlocked';
    } else if (badge) {
      badge.remove();
    }

    var nudge = el.querySelector('[data-kg-tier-nudge]');
    if (nudge) {
      if (eligible >= t3) {
        nudge.innerHTML = 'Top tier unlocked. <strong>' + p3 + '% off</strong> applied at checkout.';
      } else if (eligible > 0) {
        nudge.innerHTML = 'Add <strong>' + money(nextMin - eligible) + '</strong> more to unlock <strong>' + nextPct + '% off</strong>.';
      } else {
        nudge.innerHTML = 'Spend <strong>' + moneyShort(t1) + '</strong> to unlock <strong>' + p1 + '% off</strong>.';
      }
    }

    [[1, t1], [2, t2], [3, t3]].forEach(function (pair) {
      var row = el.querySelector('[data-kg-tier-row="' + pair[0] + '"]');
      if (!row) return;
      var hit = eligible >= pair[1];
      row.classList.toggle('is-active', hit);
      var mark = row.querySelector('.kg-tier__mark');
      if (mark) mark.innerHTML = hit ? '&#10003;' : '0' + pair[0];
    });

    var note = el.querySelector('[data-kg-tier-excluded]');
    if (note) note.hidden = excluded === 0;
  }

  function refresh() {
    var els = document.querySelectorAll('[data-kg-tier]');
    if (!els.length) return;
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var eligible = 0, excluded = 0;
        (cart.items || []).forEach(function (i) {
          if (isExcluded(i)) excluded += i.original_line_price;
          else eligible += i.original_line_price;
        });
        document.querySelectorAll('[data-kg-tier]').forEach(function (el) {
          var end = +el.dataset.kgTierEnd;
          if (end && Math.floor(Date.now() / 1000) >= end) { el.remove(); return; }
          render(el, eligible, excluded);
        });
      })
      .catch(function () {});
  }

  ['on:cart:add', 'on:cart:change', 'on:cart:after-merge'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });
})();
